import * as mLatestEventsActions from '../actions/mLatestEventsActions';
import EventItem from './EventItem';
// import moment from './MLatestNews';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


const PRODUCTS_PER_PAGE = 3;


class MLatestEvents extends React.Component{
  state = {
    currentPage: 1,
  };


  componentDidMount(){
    //console.log(`MEvents.componentDidMount()`, this.props);
    this.props.actions.initMLatestEvents({
      program: this.props.program,
      relatedProgram: this.props.relatedProgram,
      relatedProject: this.props.relatedProject,
      relatedTag: this.props.relatedTag,
    }).then(results => {
      this.props.onLoad ? this.props.onLoad(results) : null;
    });
  }


  renderEvents(){
    const events = this.props.mLatestEvents.events.sort((a, b) => {
      return moment(b.eventDate).valueOf() - moment(a.eventDate).valueOf();
    }).slice(0, PRODUCTS_PER_PAGE);

    return events.map(event => {
      return (
        <div key={event.id} className="col-12 events__listing-item">
          <EventItem event={event}
                     disableDate
                     disableLocation
                     disableDescription={!this.props.horizontal}/>
        </div>
      );
    });
  }
  renderLink(){
    let url = '/events';
    if(this.props.program)
      url = `/events?program=${this.props.program.id}`;
    if(this.props.relatedProject && this.props.relatedProject.program)
      url = `/events?program=${this.props.relatedProject.program._id}`;
    const label = this.props.viewAllLabel || (this.props.compact ? 'View all' : 'View All Events');

    if(this.props.compact) return (
      <SuperLink to={url} className="m-latest-events__view-all-link">{label}</SuperLink>
    );
    if(this.props.horizontal) return (
      <center>
        <SuperLink to={url} className="m-latest-events__view-all tg-button tg-button--pill tg-button--black">
          <span className="tg-button__label">{label}</span>
        </SuperLink>
      </center>
    );
    else return (
      <div className="navigationlink navigationlink--blue-outline">
        <SuperLink to={url} className="navigationlink__link">
          <div className="navigationlink__title">{label}</div>
        </SuperLink>
      </div>
    );
  }
  renderTitle(){
    const TitleTag = this.props.compact ? 'h2' : 'div';
    if(this.props.program && (this.props.program.Title || this.props.program.title))
      return (
        <TitleTag className="m-latest-events__title">{`LATEST ${this.props.program.Title || this.props.program.title} EVENTS And Meetings`}</TitleTag>
      );
    else return (
      <TitleTag className="m-latest-events__title">
        {this.props.title || `LATEST EVENTS`}
      </TitleTag>
    );
  }
  render(){
    // console.log(`MLatestEvents render`, this.props);
    if(!this.props.mLatestEvents ||
       !this.props.mLatestEvents.events ||
       this.props.mLatestEvents.events.length < 1) return null;

    const listing = (
      <React.Fragment>
        {this.props.compact ? (
          <div className="m-latest-events__header">
            {this.renderTitle()}
            {this.renderLink()}
          </div>
        ) : this.renderTitle()}
        <div className="events__listing">
          <div className="row">{this.renderEvents()}</div>
        </div>
        {this.props.compact ? null : this.renderLink()}
      </React.Fragment>
    );

    return (
      <div className={`m-latest-events ${this.props.compact ? 'm-latest-events--compact' : ''} ${this.props.className || ''}`}>
        {this.props.compact ? listing : (
          <div className="container container--coupling">
            {listing}
          </div>
        )}
      </div>
    );
  }
}


export default withRouter(connect(
  state => ({
    mLatestEvents: state.mLatestEvents,
  }),
  dispatch => ({
    actions: bindActionCreators(mLatestEventsActions, dispatch),
  }),
)(MLatestEvents));


MLatestEvents.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  compact: PropTypes.bool,
  horizontal: PropTypes.bool,
  mLatestEvents: PropTypes.object,
  onLoad: PropTypes.func,
  program: PropTypes.object,
  relatedProgram: PropTypes.object,
  relatedProject: PropTypes.object,
  relatedTag: PropTypes.object,
  title: PropTypes.string,
  viewAllLabel: PropTypes.string,
};
